// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"vB","blender_bottle_img":"wB","blender_bottle_info":"xB","blender_bottle_title":"yB","blender_bottle_bold":"zB","blender_bottle_usual":"AB","blender_bottle_item_mob":"BB","addbutton":"CB","blender_bottle_title_mob":"EB","blender_bottle_bold_mob":"FB","blender_bottle_usual_mob":"GB","bolder":"HB","bottom_margin_4":"IB","bottom_margin_16":"JB"};
    if(module.hot) {
      // 1714422956058
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  